export const FIND_OR_CREATE_REQUESTED = 'find_or_create_requested';
export const FIND_OR_CREATE_SUCCESS = 'find_or_create_success';
export const FIND_OR_CREATE_FAILURE = 'find_or_create_failure';

export const STORE_FIND_OR_CREATE_REQUESTED = 'store_find_or_create_requested';
export const STORE_FIND_OR_CREATE_SUCCESS = 'store_find_or_create_success';
export const STORE_FIND_OR_CREATE_FAILURE = 'store_find_or_create_failure';



export const USER_FIND_REQUESTED = 'user_find_requested';
export const USER_FIND_SUCCESS = 'user_find_success';
export const USER_FIND_FAILURE = 'user_find_failure';

export const USERS_INDEX_REQUESTED = 'users_index_requested';
export const USERS_INDEX_SUCCESS = 'users_index_success';
export const USERS_INDEX_FAILURE = 'users_index_failure';

export const USER_CREATE_REQUESTED = 'user_create_requested';
export const USER_CREATE_SUCCESS = 'user_create_success';
export const USER_CREATE_FAILURE = 'user_create_failure';

export const USER_DELETE_REQUESTED = 'user_delete_requested';
export const USER_DELETE_SUCCESS = 'user_delete_success';
export const USER_DELETE_FAILURE = 'user_delete_failure';

export const USER_UPDATE_REQUESTED = 'user_update_requested';
export const USER_UPDATE_SUCCESS = 'user_update_success';
export const USER_UPDATE_FAILURE = 'user_update_failure';

export const INSTALL_REQUESTED = 'install_requested';
export const INSTALL_SUCCESS = 'install_success';
export const INSTALL_FAILURE = 'install_failure';

export const SETTINGS_REQUESTED = 'settings_requested';
export const SETTINGS_SUCCESS = 'settings_success';
export const SETTINGS_FAILURE = 'settings_failure';

export const SETTINGS_UPDATE_REQUESTED = 'settings_update_requested';
export const SETTINGS_UPDATE_SUCCESS = 'settings_update_success';
export const SETTINGS_UPDATE_FAILURE = 'settings_update_failure';

export const LOCATIONS_INDEX_REQUESTED = 'locations_index_requested';
export const LOCATIONS_INDEX_SUCCESS = 'locations_index_success';
export const LOCATIONS_INDEX_FAILURE = 'locations_index_failure';

export const CART_LAYOUTS_REQUESTED = 'cart_layouts_requested';
export const CART_LAYOUTS_SUCCESS = 'cart_layouts_success';
export const CART_LAYOUTS_FAILURE = 'cart_layouts_failure';

export const CART_LAYOUT_FIND_REQUESTED = 'cart_layout_find_requested';
export const CART_LAYOUT_FIND_SUCCESS = 'cart_layout_find_success';
export const CART_LAYOUT_FIND_FAILURE = 'cart_layout_find_failure';

export const CART_LAYOUT_CREATE_REQUESTED = 'cart_layout_create_requested';
export const CART_LAYOUT_CREATE_SUCCESS = 'cart_layout_create_success';
export const CART_LAYOUT_CREATE_FAILURE = 'cart_layout_create_failure';

export const CART_LAYOUT_UPDATE_REQUESTED = 'cart_layout_update_requested';
export const CART_LAYOUT_UPDATE_SUCCESS = 'cart_layout_update_success';
export const CART_LAYOUT_UPDATE_FAILURE = 'cart_layout_update_failure';

export const CART_LAYOUT_DELETE_REQUESTED = 'cart_layout_delete_requested';
export const CART_LAYOUT_DELETE_SUCCESS = 'cart_layout_delete_success';
export const CART_LAYOUT_DELETE_FAILURE = 'cart_layout_delete_failure';

export const LOGIN_CODES_INDEX_REQUESTED = 'login_codes_index_requested';
export const LOGIN_CODES_INDEX_SUCCESS = 'login_codes_index_success';
export const LOGIN_CODES_INDEX_FAILURE = 'login_codes_index_failure';

export const LOGIN_CODE_CREATE_REQUESTED = 'login_code_create_requested';
export const LOGIN_CODE_CREATE_SUCCESS = 'login_code_create_success';
export const LOGIN_CODE_CREATE_FAILURE = 'login_code_create_failure';

export const LOGIN_CODE_UPDATE_REQUESTED = 'login_code_update_requested';
export const LOGIN_CODE_UPDATE_SUCCESS = 'login_code_update_success';
export const LOGIN_CODE_UPDATE_FAILURE = 'login_code_update_failure';

export const LOGIN_CODE_DELETE_REQUESTED = 'login_code_delete_requested';
export const LOGIN_CODE_DELETE_SUCCESS = 'login_code_delete_success';
export const LOGIN_CODE_DELETE_FAILURE = 'login_code_delete_failure';

export const ORDER_SHIPMENTS_INDEX_REQUESTED = 'order_shipments_index_requested';
export const ORDER_SHIPMENTS_INDEX_SUCCESS = 'order_shipments_index_success';
export const ORDER_SHIPMENTS_INDEX_FAILURE = 'order_shipments_index_failure';

export const ORDER_SHIPMENT_PREPARE_REQUESTED = 'order_shipment_prepare_requested';
export const ORDER_SHIPMENT_PREPARE_SUCCESS = 'order_shipment_prepare_success';
export const ORDER_SHIPMENT_PREPARE_FAILURE = 'order_shipment_prepare_failure';
export const ORDER_SHIPMENTS_PREPARE_RESET = 'order_shipments_prepare_reset';

export const ORDER_SHIPMENTS_PREPARE_ALL_REQUESTED = 'order_shipments_prepare_all_requested';
export const ORDER_SHIPMENTS_PREPARE_ALL_SUCCESS = 'order_shipments_prepare_all_success';
export const ORDER_SHIPMENTS_PREPARE_ALL_FAILURE = 'order_shipments_prepare_all_failure';

export const ORDER_SHIPMENTS_CONVERT_TO_TOTES_REQUESTED = 'order_shipments_convert_to_totes_requested';
export const ORDER_SHIPMENTS_CONVERT_TO_TOTES_SUCCESS = 'order_shipments_convert_to_totes_success';
export const ORDER_SHIPMENTS_CONVERT_TO_TOTES_FAILURE = 'order_shipments_convert_to_totes_failure';

export const TOTES_INDEX_REQUESTED = 'totes_index_requested';
export const TOTES_INDEX_SUCCESS = 'totes_index_success';
export const TOTES_INDEX_FAILURE = 'totes_index_failure';

export const TOTES_UNDO_REQUESTED = 'totes_undo_requested';
export const TOTES_UNDO_SUCCESS = 'totes_undo_success';
export const TOTES_UNDO_FAILURE = 'totes_undo_failure';

export const TOTES_DELETE_REQUESTED = 'totes_delete_requested';
export const TOTES_DELETE_SUCCESS = 'totes_delete_success';
export const TOTES_DELETE_FAILURE = 'totes_delete_failure';

export const TOTES_ASSIGN_REQUESTED = 'totes_assign_requested';
export const TOTES_ASSIGN_SUCCESS = 'totes_assign_success';
export const TOTES_ASSIGN_FAILURE = 'totes_assign_failure';

export const BATCHES_INDEX_REQUESTED = 'batches_index_requested';
export const BATCHES_INDEX_SUCCESS = 'batches_index_success';
export const BATCHES_INDEX_FAILURE = 'batches_index_failure';

export const BATCHES_STATS_REQUESTED = 'batches_stats_requested';
export const BATCHES_STATS_SUCCESS = 'batches_stats_success';
export const BATCHES_STATS_FAILURE = 'batches_stats_failure';

export const BATCH_FIND_REQUESTED = 'batch_find_requested';
export const BATCH_FIND_SUCCESS = 'batch_find_success';
export const BATCH_FIND_FAILURE = 'batch_find_failure';

export const PACKING_RULES_INDEX_REQUESTED = 'packing_rules_index_requested';
export const PACKING_RULES_INDEX_SUCCESS = 'packing_rules_index_success';
export const PACKING_RULES_INDEX_FAILURE = 'packing_rules_index_failure';

export const PACKING_RULE_CREATE_REQUESTED = 'packing_rule_create_requested';
export const PACKING_RULE_CREATE_SUCCESS = 'packing_rule_create_success';
export const PACKING_RULE_CREATE_FAILURE = 'packing_rule_create_failure';

export const PACKING_RULE_UPDATE_REQUESTED = 'packing_rule_update_requested';
export const PACKING_RULE_UPDATE_SUCCESS = 'packing_rule_update_success';
export const PACKING_RULE_UPDATE_FAILURE = 'packing_rule_update_failure';

export const PACKING_RULE_DELETE_REQUESTED = 'packing_rule_delete_requested';
export const PACKING_RULE_DELETE_SUCCESS = 'packing_rule_delete_success';
export const PACKING_RULE_DELETE_FAILURE = 'packing_rule_delete_failure';

export const PACKING_RULE_FILE_UPLOAD_REQUESTED = 'packing_rule_file_upload_requested';
export const PACKING_RULE_FILE_UPLOAD_SUCCESS = 'packing_rule_file_upload_success';
export const PACKING_RULE_FILE_UPLOAD_FAILURE = 'packing_rule_file_upload_failure';



// export const _REQUESTED = '_requested';
// export const _SUCCESS = '_success';
// export const _FAILURE = '_failure';

export const PRODUCTS_SEARCH_REQUESTED = 'products_search_requested';
export const PRODUCTS_SEARCH_SUCCESS = 'products_search_success';
export const PRODUCTS_SEARCH_FAILURE = 'products_search_failure';
export const PRODUCTS_SEARCH_RESET = 'products_search_reset';

export const COLLECTIONS_INDEX_REQUESTED = 'collections_index_requested';
export const COLLECTIONS_INDEX_SUCCESS = 'collections_index_success';
export const COLLECTIONS_INDEX_FAILURE = 'collections_index_failure';

export const TAGS_INDEX_REQUESTED = 'tags_index_requested';
export const TAGS_INDEX_SUCCESS = 'tags_index_success';
export const TAGS_INDEX_FAILURE = 'tags_index_failure';

export const AUDIT_LOGS_INDEX_REQUESTED = 'audit_logs_index_requested';
export const AUDIT_LOGS_INDEX_SUCCESS = 'audit_logs_index_success';
export const AUDIT_LOGS_INDEX_FAILURE = 'audit_logs_index_failure';
